import {dataTableGroupValueStrategy} from "../../../../../services/common";

const debts2 = (currentVal, row) => {
    return {
        cash: dataTableGroupValueStrategy.arrayMoneySum('cash')(
            currentVal ? currentVal.cash : null,
            row.debts2
        ),
        cashless: dataTableGroupValueStrategy.arrayMoneySum('cashless')(
            currentVal ? currentVal.cashless : null,
            row.debts2
        ),
        total: dataTableGroupValueStrategy.arrayMoneySum('total')(
            currentVal ? currentVal.total : null,
            row.debts2
        ),
    };
};

export default debts2;
